import React, { memo } from 'react';
import { SidebarBoundary } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-common-core/src/ui/sidebar-boundary/index.tsx';
import { Skeleton } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-settings-project-common/src/common/ui/skeleton/index.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { Props } from './types.tsx';

const LazySidebarContent = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "async-jira-navigation-apps-sidebar-nav4-business-team-managed-project-settings" */ './main'
		),
	{
		includeInShellOnlySsrBundle: true,
		entryFsSsrLiftImportToModule: true,
	},
);

const AsyncSidebar = ({ project }: Props): React.JSX.Element => (
	<SidebarBoundary
		id="nav4.sidebar.project-settings.business.team-managed"
		packageName="jiraNavigationAppsSidebarNav4BusinessTeamManagedProjectSettings"
		ufoName="nav4.sidebar.project-settings.business.team-managed"
	>
		<Placeholder name="nav4.sidebar.project-settings.business.team-managed" fallback={<Skeleton />}>
			<LazySidebarContent project={project} />
		</Placeholder>
	</SidebarBoundary>
);

export default memo(AsyncSidebar);
